import { generatePath } from 'react-router-dom'

import { OrderStatus } from '__generated__/atlas-types'

import { fromGlobalId } from 'utils/transformations/graphql'

import { poLinkTypes } from 'modals/Shop/AddSelectsToAssortmentModal/common'
import {
  NEW_ORDER_REVIEW,
  ORDERS_CART,
  ORDER_LIST,
  ORDER_MODIFY,
} from 'routes/paths'

export const getLinkToAssortment = (assortment) => {
  // TODO(daveanderson) after all assortment pages are in GraphQL
  // - do not decode base 64 GUID
  const { id: assortmentId } = fromGlobalId(assortment.id)
  const pathname = `/assortments/get_assortment/${assortmentId}`

  const { id: brandId } = assortment.brand
    ? fromGlobalId(assortment.brand.id)
    : {}
  const search = brandId ? `?brandId=${brandId}` : undefined

  return { pathname, search }
}

export const getAssortmentsUiURL = (assortmentId) => {
  const link = getLinkToWorkspaces({ id: assortmentId }, poLinkTypes.OVERVIEW)
  const path = `${link.pathname}${link.hash}`
  return `${link.baseURL}${path}`
}

// suffix should be of type poLinkTypes
export const getLinkToWorkspaces = (assortment, suffix = '') => {
  const { id: assortmentId } = fromGlobalId(assortment.id)
  const hash = `#/workspaces/${assortmentId}` + suffix
  const baseURL = window.location.origin
  const pathname = `/ra/assortments`
  return {
    pathname,
    hash,
    baseURL,
  }
}

export const getLinkToWorkspaceOverview = (workspace, suffix = '') => {
  const { id: workspaceId } = fromGlobalId(workspace.id)
  const hash = `#/workspace/${workspaceId}` + suffix
  const baseURL = window.location.origin
  const pathname = `/ra/assortments`
  return {
    pathname,
    hash,
    baseURL,
  }
}

export const openMultiPOWorkspace = (workspaceId) => {
  const workspaceLink = getLinkToWorkspaceOverview(
    { id: workspaceId },
    poLinkTypes.OVERVIEW,
  )
  window.open(
    workspaceLink.baseURL + workspaceLink.pathname + workspaceLink.hash,
  )
}

export const openWorkspacesOverview = (id) => {
  const assortmentLink = getLinkToWorkspaces({ id })
  window.open(
    assortmentLink.baseURL +
      assortmentLink.pathname +
      assortmentLink.hash +
      poLinkTypes.OVERVIEW,
  )
}

export const openWorkspacesProducts = (id) => {
  const assortmentLink = getLinkToWorkspaces({ id })
  window.open(
    assortmentLink.baseURL +
      assortmentLink.pathname +
      assortmentLink.hash +
      poLinkTypes.PRODUCTS,
  )
}

export const getWorkspacesURL = (
  assortmentId,
  poLinkType = poLinkTypes.OVERVIEW,
) => {
  const link = getLinkToWorkspaces({ id: assortmentId })
  const path = `${link.pathname}${link.hash}`
  return `${link.baseURL}${path}${poLinkType}`
}

export const getLinkToAssortmentUnits = (assortment) => {
  const { pathname, search } = getLinkToAssortment(assortment)
  return { pathname: `${pathname}/units`, search }
}

export const getLinkToAssortmentEditStyles = (assortment) => {
  const { pathname, search } = getLinkToAssortment(assortment)
  return { pathname: `${pathname}/styles`, search }
}

export const getLinkToAssortmentEditAttributes = (assortment) => {
  const { pathname, search } = getLinkToAssortment(assortment)
  return { pathname: `${pathname}/attributes`, search }
}

export const getLinkToOrder = (order, isCartDeprecated) => {
  const orderId = fromGlobalId(order.id)?.id
  if (order.status === OrderStatus.IN_PROGRESS && !isCartDeprecated) {
    return ORDERS_CART
  }
  return generatePath(NEW_ORDER_REVIEW, {
    id: orderId,
  })
}

export const getLinkToOrderReview2023 = ({
  order,
  isCartDeprecated = false,
}) => {
  if (!order.status) {
    return ORDER_LIST
  }

  if (order.status === OrderStatus.IN_PROGRESS && !isCartDeprecated) {
    return ORDERS_CART
  }

  return generatePath(NEW_ORDER_REVIEW, {
    id: order.id,
  })
}

export const getOrderEditProductsLink = ({ order, canEditProducts }) => {
  if (!order.status || !canEditProducts) {
    return ORDER_LIST
  }

  const modifyLink = generatePath(ORDER_MODIFY, {
    orderId: order.webOrderLookupId,
  })
  const redirectToModify = `${modifyLink}?order_id=${order.id}`

  if (canEditProducts) {
    return redirectToModify
  }
}

export const getLinkToStyle = (style) =>
  `/styles/view/${fromGlobalId(style.id).id}`

export const getLinkToCustomReport = (id) => `/reports/custom_report/${id}`
